import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Button, Input, Table, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { useHistory } from 'react-router-dom';
import { AvForm, AvField } from "availity-reactstrap-validation";
import { handleStatusChange, handleDelete } from '../../components/Common/ActiveStatusChange';
import ActionsDropdown from '../../components/Common/DropDown';
import { BASE_URL, useJwtToken } from '../../components/Common/AppConfig';
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import SetAlert from '../../components/Common/SetAlert';
import { CSVLink } from 'react-csv';
import Select from "react-select";
function OrganiserMaster() {
    const [userDetails, setUserDetails] = useState([]);
    const [userTagDetails, setUserTagDetails] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [selectedUser, setSelectedUser] = useState({});
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [alertMessage, setAlertMessage] = useState({ success: '', error: '' });
    const [isModalOpenUser, setIsModalOpenUser] = useState(false);
    const token = useJwtToken();
    const [selectedRole, setSelectedRole] = useState(null);
    const history = useHistory();
    const toggleAddModal = () => {
        setAddModalOpen(!addModalOpen);
    };

    const handleAddUser = () => {
        setFormData({
            role: '',
            fname: '',
            lname: '',
            phone: '',
            email: '',
            password: '',
            interest_tags: [],
            workExperience: [
                {
                    companyName: '',
                    companyLogo: '',
                    position: '',
                    startDate: '',
                    endDate: '',
                    shortDesc: '',
                },
            ],
            expertise_tags: [],
            address: '',
            linkedAccounts: [
                {
                    type: '',
                    url: ''
                }
            ],
            bio: '',
        });
        toggleAddModal();
    };

    const [formData, setFormData] = useState({
        role: '',
        fname: '',
        lname: '',
        phone: '',
        email: '',
        password: '',
        interest_tags: [],
        workExperience: [
            {
                companyName: '',
                companyLogo: '',
                position: '',
                startDate: '',
                endDate: '',
                shortDesc: '',
            },
        ],
        expertise_tags: null,
        address: '',
        linkedAccounts: [
            {
                type: '',
                url: ''
            }
        ],
        bio: '',
    });

    const handleInputChange = (e, index) => {

        setFormData({ ...formData, [e.target.name]: e.target.value });

    };

    const handleAdd = async (e) => {
        e.preventDefault();
        setFormSubmitted(true);
        setSubmitting(true);
        formData.workExperience.forEach((experience, index) => {
            validateStartDate(experience.startDate);
            validateEndDate(experience.endDate, experience.startDate);
        });

        // Check if any date is invalid
        if (isInvalidStartDate || isInvalidEndDate) {
            setSubmitting(false);
            return;
        }
        if (!selectedUser.o_photo) {
            setErrorMessageModel('Please upload a file.');
            return;
        }
        try {
            const form = new FormData();
            form.append('role', formData.role);
            form.append('fname', formData.fname);
            form.append('lname', formData.lname);
            form.append('phone', formData.phone);
            form.append('email', formData.email);
            form.append('password', formData.password);
            form.append('interest_tags', JSON.stringify(formData.interest_tags));
            form.append('workExperience', JSON.stringify(formData.workExperience)); // Wrap in an array and stringify
            form.append('linkedAccounts', JSON.stringify(formData.linkedAccounts)); // Wrap in an array and stringify
            form.append('expertise_tags', JSON.stringify(formData.expertise_tags));
            form.append('address', formData.address);
            form.append('bio', formData.bio);
            form.append('o_photo', selectedUser.o_photo);
            const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
            const maxFileSize = 2 * 1024 * 1024;

            console.log('formData:', formData);

            if (!allowedTypes.includes(selectedUser.o_photo.type)) {
                setErrorMessage('Invalid file type. Please upload a PNG, JPG, or JPEG file.');
                return;
            }
            if (selectedUser.o_photo.size > maxFileSize) {
                setErrorMessage('File size limit exceeded. Please upload a file up to 2MB.');
                return;
            }
            const headers = {
                'Authorization': token,
            };
            const response = await fetch(`${BASE_URL}/organiser`, {
                method: 'POST',
                body: form,
                headers: headers

            });
            const data = await response.json();
            console.log(data.data)
            if (response.ok) {
                setUserDetails([...userDetails, data]);
                setFormData({
                    role: '',
                    fname: '',
                    lname: '',
                    phone: '',
                    email: '',
                    password: '',
                    interest_tags: '',
                    workExperience: '',
                    expertise_tags: '',
                    address: '',
                    linkedAccounts: '',
                    bio: '',
                });
                toggleAddModal();
                fetchOrganiserDetails();
                history.push('/organiser');
                setAlertMessage({ success: 'Organiser added successfully!', error: '' });
            } else {
                setAlertMessage({ success: '', error: 'An error occurred while adding the organiser.' });
            }
        } catch (error) {
            console.log(error);
            setAlertMessage({ success: '', error: 'An error occurred while adding the organiser.' });
        } finally {
            setSubmitting(false);
        }
    };

    const handleO_photoChange = (event) => {
        const file = event.target.files[0];
        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        const maxFileSize = 2 * 1024 * 1024; // 2MB
        setSelectedUser((prevSelectedUser) => ({
            ...prevSelectedUser,
            o_photo: file,
            imageName: file ? file.name : '',
        }));
        if (file && allowedTypes.includes(file.type) && file.size <= maxFileSize) {
            console.log('Valid file:', file);
            setErrorMessage('');
        } else {
            console.log('Invalid file');
            setErrorMessage('Invalid file. Please upload a PNG, JPG, or JPEG file within 2MB.');
        }
    };


    useEffect(() => {
        fetchOrganiserDetails();
        fetchUserTags();
    }, []);

    const fetchOrganiserDetails = async () => {
        try {
            const headers = {
                'Authorization': token,
                'Content-Type': 'application/json',

            };

            const response = await fetch(`${BASE_URL}/organiser`, {
                method: 'GET',
                headers: headers,
            });
            const data = await response.json();
            if (response.ok) {
                const dataWithSerialNo = data.data.map((item, index) => ({ ...item, srNo: index + 1 }));
             
                setUserDetails(dataWithSerialNo);
            } else {
                setAlertMessage({ success: '', error: 'Failed to fetch organiser details.' });
            }
        } catch (error) {
            setAlertMessage({ success: '', error: 'An error occurred while fetching organiser data' });
            console.error(error);
        }
    };

    const fetchUserTags = async () => {
        try {
            const headers = {
                'Authorization': token,
                'Content-Type': 'application/json',
            };

            const response = await fetch(`${BASE_URL}/usertags`, {
                method: 'GET',
                headers: headers,
            });
            const data = await response.json();
            if (response.ok) {
                setUserTagDetails(data.data);

            } else {
                setAlertMessage({ success: '', error: 'Failed to fetch organiser details.' });
            }
        } catch (error) {
            setAlertMessage({ success: '', error: 'An error occurred while fetching organiser data' });
            console.error(error);
        }
    };

    const toggleDropdown = (row) => {
        row.dropdownOpen = !row.dropdownOpen;
        setDropdownOpen(!dropdownOpen);
        setUserDetails([...userDetails]);
    };

    const handleEdit = (user) => {
        setSelectedUser(user);
        toggleEditModal();
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedUser((prevUser) => ({
            ...prevUser,
            [name]: value,
        }));
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };


    const handleDeleteClick = (_id) => {
        const Page_Url = `${BASE_URL}/organiser/${_id}`;
        handleDelete(_id, Page_Url, fetchOrganiserDetails, setAlertMessage, token);
    };

    const handleActiveClick = (_id) => {
        const Page_Url = `${BASE_URL}/organiser/status/${_id}`;
        const isActive = 1;
        const successMessageProp = 'Activated Organiser Successfully';
        const errorMessageProp = 'Failed to Organiser Agenda';
        handleStatusChange(isActive, _id, Page_Url, fetchOrganiserDetails, successMessageProp, errorMessageProp, setAlertMessage, token);
    };

    const handleDeactiveClick = (_id) => {
        const Page_Url = `${BASE_URL}/organiser/status/${_id}`;
        const isActive = 0;
        const successMessageProp = 'Deactivated Organiser Successfully';
        const errorMessageProp = 'Failed to Deactivate Organiser';
        handleStatusChange(isActive, _id, Page_Url, fetchOrganiserDetails, successMessageProp, errorMessageProp, setAlertMessage, token);
    };

    const handleAction = (action, row) => {
        if (action.toLowerCase() === 'edit') {
            handleEdit(row);
        } else if (action.toLowerCase() === 'delete') {
            handleDeleteClick(row._id);
        } else if (action.toLowerCase() === 'active') {
            handleActiveClick(row._id);
        } else if (action.toLowerCase() === 'deactive') {
            handleDeactiveClick(row._id);
        }
    };

    const renderActionsDropdown = (row) => (
        <ActionsDropdown
            row={row}
            toggleDropdown={toggleDropdown}
            handleAction={handleAction}
            isActive={row.isActive}
            showEdit={true}
        />
    );
    const filteredData = userDetails.filter((user) => {
        const { _id, fname, phone, email } = user;
        const lowercasedSearchText = searchText.toLowerCase();

        return (
            (_id && _id.toString().includes(lowercasedSearchText)) ||
            ((fname) && (fname).toLowerCase().includes(lowercasedSearchText)) ||
            (phone && phone.toLowerCase().includes(lowercasedSearchText)) ||
            (email && email.toLowerCase().includes(lowercasedSearchText))
        );
    });

    let serialNumber = 1;
    const columns = [
        {
            name: '#',
            cell: (row) => row.srNo,
            sortable: true,
            width: '70px'
        },
        { name: 'Name', selector: (row) => row.fname + " " + row.lname, sortable: true, },
        { name: 'Phone', selector: (row) => row.phone, sortable: true },
      
        { name: 'Created Date', selector: (row) => row.createdDate || '', sortable: true },
        {
            name: 'More Details',
            cell: (row) => (
                <button className='btn btn-primary' onClick={() => handleOpenModalUser(row)}>Details</button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '150px',
            style: {
                textAlign: 'center',
            },
        },
        {
            name: 'Active',
            cell: (row) => (
                <span style={{ color: row.isActive === 1 ? 'green' : 'red' }}>
                    {row.isActive === 1 ? 'Active' : 'Inactive'}
                </span>
            ),
            sortable: true,
            width: '100px'
        },
        {
            name: 'Action',
            cell: (row) => renderActionsDropdown(row),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ]


    const toggleEditModal = () => {
        setEditModalOpen(!editModalOpen);
    };

    const handleEditUser = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        console.log(formData)
        try {
            const formData = new FormData();
            const matchingTags = selectedUser.interest_tags.map(tagId => {
                const matchingTag = userTagDetails.find(tag => tag._id === tagId);
                return matchingTag ? {
                    tag_id: matchingTag._id,
                    uTags: matchingTag.uTags
                } : null;
            }).filter(tag => tag !== null);

            const matchingTags1 = selectedUser.expertise_tags.map(tagId => {
                const matchingTag1 = userTagDetails.find(tag => tag._id === tagId);
                return matchingTag1 ? {
                    expertise_id: matchingTag1._id,
                    uTags: matchingTag1.uTags
                } : null;
            }).filter(tag => tag !== null);
            console.log()
            formData.append('role', selectedUser.role);
            formData.append('fname', selectedUser.fname);
            formData.append('lname', selectedUser.lname);
            formData.append('phone', selectedUser.phone);
            formData.append('email', selectedUser.email);
            formData.append('password', selectedUser.password);
            formData.append('interest_tags', JSON.stringify(matchingTags));
            formData.append('workExperience', JSON.stringify(selectedUser.workExperience));
            formData.append('expertise_tags', JSON.stringify(matchingTags1));
            formData.append('address', selectedUser.address);
            formData.append('linkedAccounts', JSON.stringify(selectedUser.linkedAccounts));
            formData.append('bio', selectedUser.bio);

            // formData.append('o_photo', selectedUser.o_photo);
            // const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
            // const maxFileSize = 2 * 1024 * 1024; // 2MB

            // if (!selectedUser.o_photo || !allowedTypes.includes(selectedUser.o_photo.type) || selectedUser.o_photo.size > maxFileSize) {
            //     console.log('Invalid file');
            //     return;
            // }

            if (selectedUser.o_photo) {
                // Append the photo only if it's a new one or if it's not the same as the existing one
                if (selectedUser.o_photo !== null) {
                    formData.append('o_photo', selectedUser.o_photo);
                } else {
                    formData.append('o_photo', selectedUser.o_photo);
                }
            }

            const response = await fetch(`${BASE_URL}/organiser/${selectedUser._id}`, {
                method: 'PUT',
                body: formData,
            });

            const responseData = await response.text();

            const data = JSON.parse(responseData);

            if (response.ok) {
                fetchOrganiserDetails();
                toggleEditModal();
                setAlertMessage({ success: 'Organiser Edited successfully!', error: '' });
            } else {
                setAlertMessage({ success: '', error: 'An error occurred while edit the organiser.' });
            }
        } catch (error) {
            console.log(error);
            setAlertMessage({ success: '', error: 'An error occurred while editing the organiser.' });
        } finally {
            setSubmitting(false);
        }
    };

    const handleDeleteUser = async () => {
        if (selectedUser) {
            await handleDelete(selectedUser._id);
            setSelectedUser(null);
            toggleEditModal();
        }
    };



    const roleOptions = [
        { value: 'admin', label: 'Admin' },
        { value: 'user', label: 'User' },
    ];

    // Function to handle the change in Select value
    const handleRoleChange = (selectedOption) => {
        setSelectedRole(selectedOption);
    };
    const handleAddWorkExperience = () => {
        setFormData((prevData) => ({
            ...prevData,
            workExperience: [
                ...prevData.workExperience,
                {
                    companyName: '',
                    companyLogo: '',
                    position: '',
                    startDate: '',
                    endDate: '',
                    shortDesc: '',
                },
            ],
        }));
    };

    const handleRemoveWorkExperience = (index) => {
        setFormData((prevData) => ({
            ...prevData,
            workExperience: prevData.workExperience.filter((_, i) => i !== index),
        }));
    };

    const handleRemoveLinkedAccount = (index) => {
        setFormData((prevData) => ({
            ...prevData,
            linkedAccounts: prevData.linkedAccounts.filter((_, i) => i !== index),
        }));
    };

    // Define state variables
    const [isInvalidStartDate, setIsInvalidStartDate] = useState(false);
    const [isInvalidEndDate, setIsInvalidEndDate] = useState(false);
    const handleStartDateChange = (index, selectedDate) => {
        const formattedStartDate = new Date(selectedDate[0]).toISOString().split('T')[0];

        setFormData((prevData) => {
            const updatedWorkExperience = [...prevData.workExperience];
            if (updatedWorkExperience[index]) { // Check if the element at the given index exists
                updatedWorkExperience[index].startDate = formattedStartDate;
            }
            return { ...prevData, workExperience: updatedWorkExperience };
        });

        validateStartDate(formattedStartDate);
    };

    const validateStartDate = (startDate) => {

        if (!startDate || new Date(startDate) > new Date()) {
            setIsInvalidStartDate(true);
        } else {
            setIsInvalidStartDate(false);
        }
    };

    const handleEndDateChange = (index, selectedDate) => {
        const formattedEndDate = new Date(selectedDate[0]).toISOString().split('T')[0];

        setFormData((prevData) => {
            const updatedWorkExperience = [...prevData.workExperience];
            console.log('updatedWorkExperience:', updatedWorkExperience);
            console.log('index:', index);

            if (updatedWorkExperience[index]) {
                updatedWorkExperience[index].endDate = formattedEndDate;
            } else {
                console.log('updatedWorkExperience[index] is undefined.');
            }
            return { ...prevData, workExperience: updatedWorkExperience };
        });

        validateEndDate(formattedEndDate, formData.workExperience[index]?.startDate);
    };




    const validateEndDate = (endDate, startDate) => {
        if (endDate === 'Present') {
            setIsInvalidEndDate(false);
            setIsInvalidStartDate(false); // Reset start date validation when 'Present' is selected
        } else if (!endDate || new Date(endDate) > new Date()) {
            setIsInvalidEndDate(true);
        } else if (startDate && new Date(endDate) < new Date(startDate)) { // Check if startDate is defined before comparing
            setIsInvalidEndDate(true);
        } else {
            setIsInvalidEndDate(false);
        }
    };



    const handleSocialAccountChange = (index, field, value) => {
        const updatedFormData = { ...formData };
        const updatedLinkedAccounts = [...updatedFormData.linkedAccounts];
        const socialAccount = updatedLinkedAccounts[index] || {};
        socialAccount[field] = value;
        updatedLinkedAccounts[index] = socialAccount;
        updatedFormData.linkedAccounts = updatedLinkedAccounts;
        setFormData(updatedFormData);

    };

    const addSocialAccountField = () => {
        const updatedFormData = { ...formData };
        updatedFormData.linkedAccounts.push({ type: '', url: '' });
        setFormData(updatedFormData);
    };

    // Function to handle changes in the edit model
    const handleEditSocialAccountChange = (index, field, value) => {
        const updatedUser = { ...selectedUser }; // Use selectedUser for editing
        updatedUser.linkedAccounts = updatedUser.linkedAccounts || [];
        const socialAccount = updatedUser.linkedAccounts[index] || {};
        socialAccount[field] = value;
        updatedUser.linkedAccounts[index] = socialAccount;
        setSelectedUser(updatedUser);
    };

    // Function to add a social account in the edit model
    const addEditSocialAccountField = () => {
        const updatedUser = { ...selectedUser };
        updatedUser.linkedAccounts = updatedUser.linkedAccounts || [];
        updatedUser.linkedAccounts.push({ type: '', url: '' });
        setSelectedUser(updatedUser);
    };

    const handleEditWorkExperience = (index, updatedExperience) => {
        console.log('Updated Experience:', updatedExperience);
        setSelectedUser((prevData) => {
            const updatedWorkExperience = [...prevData.workExperience];
            updatedWorkExperience[index] = updatedExperience;
            console.log('Updated Work Experience:', updatedWorkExperience);
            return { ...prevData, workExperience: updatedWorkExperience };
        });
    };

    const handleAddWorkExperienceEdit = () => {
        setSelectedUser((prevUser) => ({
            ...prevUser,
            workExperience: [
                ...prevUser.workExperience,
                {
                    companyName: '',
                    companyLogo: '',
                    position: '',
                    startDate: '',
                    endDate: '',
                    shortDesc: '',
                },
            ],
        }));
    };

    const handleRemoveWorkExperienceEdit = (index) => {
        setSelectedUser((prevUser) => ({
            ...prevUser,
            workExperience: prevUser.workExperience.filter((_, i) => i !== index),
        }));
    };


    const handleRemoveLinkedAccountEdit = (index) => {
        setSelectedUser((prevUser) => ({
            ...prevUser,
            linkedAccounts: prevUser.linkedAccounts.filter((_, i) => i !== index),
        }));
    };

    function handleContactNumberKeyDown(event) {
        const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight'];
        const { key } = event;

        if (!allowedKeys.includes(key) && !/\d/.test(key)) {
            event.preventDefault();
        }

        const { value } = event.target;
        if (value.length >= 11 && !allowedKeys.includes(key)) {
            event.preventDefault();
        }
    }

    const handleOpenModalUser = (row) => {
        setSelectedUser(row);
        setIsModalOpenUser(true);
    };
    const handleCloseModalUser = () => {
        setIsModalOpenUser(false);
    };
    const isUserSelected = Object.keys(selectedUser).length > 0;



    return (
        <div className="content">
            <Row>
                <Col md="12">
                    <Card>
                        <CardHeader>
                            <CardTitle tag="h4">Organiser Details</CardTitle>
                        </CardHeader>
                        <CardBody className='mb-4'>
                            <Row>
                                <Col md="8" className="d-flex justify-content-start mb-3">
                                    <CSVLink data={userDetails} filename='OrganiserData' className='btn btn-primary'>Export to Excel</CSVLink>
                                </Col>
                                <Col md="4" className="d-flex justify-content-end mb-3">
                                    <Input
                                        type="text"
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        style={{ borderRadius: '20px', marginRight: '10px' }}
                                    />
                                    <Button color="primary" onClick={handleAddUser}>
                                        Add
                                    </Button>
                                </Col>

                            </Row>
                            <SetAlert alertMessage={alertMessage} setAlertMessage={setAlertMessage} />
                            <DataTable className='table-nowrap custom-data-table' columns={columns} data={filteredData} pagination highlightOnHover noHeader responsive keyField="_id" />
                        </CardBody>
                    </Card>

                </Col>
            </Row>
            <Modal isOpen={addModalOpen} toggle={toggleAddModal} backdrop="static">
                <ModalHeader toggle={toggleAddModal}>Add Organiser</ModalHeader>
                <ModalBody>
                    <SetAlert alertMessage={alertMessage} setAlertMessage={setAlertMessage} />

                    <AvForm onValidSubmit={handleAdd}>
                        <div className="form-group mb-2">
                            <label htmlFor="role">Role</label>
                            <Select
                                className="basic-single"
                                classNamePrefix="select"
                                name="role"
                                placeholder="Select Role"
                                value={formData.role ? { value: formData.role, label: formData.role } : null}
                                options={[
                                    { value: 'admin', label: 'Admin' },
                                    { value: 'user', label: 'User' },
                                ]}
                                onChange={(selectedOption) => setFormData({ ...formData, role: selectedOption ? selectedOption.value : '' })}
                                isClearable={true}
                                formatOptionLabel={({ label }) => <div>{label}</div>} // Customize the label appearance
                            />
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group mb-2">
                                    <label htmlFor="fname">First Name</label>
                                    <AvField
                                        type="text"
                                        className="form-control"
                                        name="fname"
                                        placeholder="Name"
                                        value={formData.fname}
                                        onChange={handleInputChange}
                                        validate={{
                                            required: { value: true, errorMessage: 'Please enter your first name' },
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group mb-2">
                                    <label htmlFor="lname">Last Name</label>
                                    <AvField
                                        type="text"
                                        className="form-control"
                                        name="lname"
                                        placeholder="Last Name"
                                        value={formData.lname}
                                        onChange={handleInputChange}
                                        validate={{
                                            required: { value: true, errorMessage: 'Please enter your first name' },
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group mb-2">
                            <label htmlFor="phone">Phone</label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="phone"
                                placeholder="Phone"
                                value={formData.phone}
                                onKeyDown={handleContactNumberKeyDown}
                                pattern="\d*"
                                maxLength="11"
                                minLength="10"

                                onChange={handleInputChange}
                                validate={{
                                    required: { value: true, errorMessage: 'Please enter your phone number' },
                                }}
                            />
                        </div>
                        <div className="form-group mb-2">
                            <label htmlFor="email">Email</label>
                            <AvField
                                type="email"
                                className="form-control"
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleInputChange}
                                validate={{
                                    required: { value: true, errorMessage: 'Please enter your email address' },
                                    email: { errorMessage: 'Invalid email address' },
                                }}
                            />
                        </div>
                        <div className="form-group mb-2">
                            <label htmlFor="password">Password</label>
                            <AvField
                                type="password"
                                className="form-control"
                                name="password"
                                placeholder="password"
                                value={formData.password}
                                onChange={handleInputChange}
                                validate={{
                                    required: { value: true, errorMessage: 'Please enter your password' },

                                }}
                            />
                        </div>

                        <div className="form-group mb-2">
                            <label htmlFor="interest_tags">Interest Tags</label>
                            <Select
                                value={Array.isArray(formData.interest_tags) ? formData.interest_tags.map(tag => ({
                                    value: tag.tag_id,
                                    label: tag.uTags
                                })) : []}
                                id="interest_tags"
                                name="interest_tags"
                                onChange={(selectedOptions) => {
                                    const selectedValues = selectedOptions ? selectedOptions.map(option => ({ tag_id: option.value, uTags: option.label })) : [];
                                    setFormData(prevFormData => ({ ...prevFormData, interest_tags: selectedValues }));
                                }}
                                options={userTagDetails
                                    .filter((tags) => tags.isActive === 1)
                                    .map((tags) => ({
                                        value: tags._id,
                                        label: tags.uTags,
                                    }))
                                }
                                getOptionLabel={(option) => option.label}
                                isMulti
                            />
                        </div>

                        <div className="form-group mt-4 d-flex flex-column align-items-center justify-content-center">
                            <label className="work-experience-label">Work Experience</label>
                        </div>
                        {Array.isArray(formData.workExperience) && formData.workExperience.map((experience, index) => (
                            <div key={index}>
                                <div className="form-group mb-2">

                                    <AvField
                                        type="text"
                                        name={`companyName-${index}`} // Unique name for each field
                                        value={experience.companyName}
                                        onChange={(e) =>
                                            setFormData((prevData) => {
                                                const updatedWorkExperience = [...prevData.workExperience];
                                                updatedWorkExperience[index].companyName = e.target.value;
                                                return { ...prevData, workExperience: updatedWorkExperience };
                                            })
                                        }
                                        label="Company Name"
                                        placeholder="Enter Company Name"
                                        required
                                    />
                                </div>
                                <div className="form-group mb-2">

                                    <AvField
                                        type="url"
                                        name={`companyLogo-${index}`} // Unique name for each field
                                        value={experience.companyLogo}
                                        onChange={(e) =>
                                            setFormData((prevData) => {
                                                const updatedWorkExperience = [...prevData.workExperience];
                                                updatedWorkExperience[index].companyLogo = e.target.value;
                                                return { ...prevData, workExperience: updatedWorkExperience };
                                            })
                                        }
                                        label="Company Logo"
                                        placeholder="Enter Company Logo URL"
                                        required
                                    />
                                </div>
                                <div className="form-group mb-2">

                                    <AvField
                                        type="text"
                                        name={`position-${index}`} // Unique name for each field
                                        value={experience.position}
                                        onChange={(e) =>
                                            setFormData((prevData) => {
                                                const updatedWorkExperience = [...prevData.workExperience];
                                                updatedWorkExperience[index].position = e.target.value;
                                                return { ...prevData, workExperience: updatedWorkExperience };
                                            })
                                        }
                                        label="Position"
                                        placeholder="Enter your position"
                                        required
                                    />
                                </div>
                                <div className="row">
                                    <div className="form-group mb-2 col-5">
                                        <label htmlFor={`startDate${index}`}>Start Date</label>
                                        <Flatpickr
                                            className={`form-control ${isInvalidStartDate ? 'is-invalid' : ''}`}
                                            value={experience.startDate}
                                            onChange={(value) => {
                                                handleStartDateChange(index, value);
                                            }}
                                            options={{
                                                dateFormat: 'Y-m-d',
                                            }}
                                            placeholder="Start Date"
                                        />
                                        {isInvalidStartDate && (
                                            <div className="invalid-feedback">Please select a valid Start Date.</div>
                                        )}
                                    </div>
                                    <div className="form-group mb-2 col-5">
                                        <label htmlFor={`endDate${index}`}>End Date</label>
                                        {experience.endDate === 'Present' ? (
                                            <input
                                                className={`form-control ${isInvalidEndDate ? 'is-invalid' : ''}`}
                                                type="text"
                                                name={`endDate-${index}`}
                                                placeholder="End Date"
                                                value="Present"
                                                onChange={(e) => {
                                                    const updatedWorkExperience = [...formData.workExperience];
                                                    updatedWorkExperience[index].endDate = e.target.value;
                                                    setFormData({ ...formData, workExperience: updatedWorkExperience });
                                                    validateEndDate('Present', experience.startDate);
                                                }}
                                                disabled
                                            />
                                        ) : (
                                            <Flatpickr
                                                className={`form-control ${isInvalidEndDate ? 'is-invalid' : ''}`}
                                                value={experience.endDate}
                                                onChange={(value) => {
                                                    handleEndDateChange(index, value);

                                                }}
                                                options={{
                                                    dateFormat: 'Y-m-d',
                                                }}
                                                placeholder="End Date"
                                            />
                                        )}
                                        {isInvalidEndDate && (
                                            <div className="invalid-feedback">Please select a valid End Date.</div>
                                        )}
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor={`presentCheckbox${index}`} className="text-center">Present</label>
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                            <input
                                                className="form-check-input text-center"
                                                type="checkbox"
                                                checked={experience.endDate === 'Present'}
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    setFormData((prevData) => {
                                                        const updatedWorkExperience = [...prevData.workExperience];
                                                        updatedWorkExperience[index].endDate = isChecked ? 'Present' : '';
                                                        return { ...prevData, workExperience: updatedWorkExperience };
                                                    });

                                                    // Reset validation when Present checkbox is checked
                                                    setIsInvalidStartDate(false);
                                                    setIsInvalidEndDate(false);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mb-2">

                                    <AvField
                                        type="textarea"
                                        name={`shortDesc-${index}`} // Unique name for each field
                                        value={experience.shortDesc}
                                        onChange={(e) =>
                                            setFormData((prevData) => {
                                                const updatedWorkExperience = [...prevData.workExperience];
                                                updatedWorkExperience[index].shortDesc = e.target.value;
                                                return { ...prevData, workExperience: updatedWorkExperience };
                                            })
                                        }
                                        label="Short Description"
                                        placeholder="Enter Short Description"
                                        required
                                    />
                                </div>
                                <div className="d-flex justify-content-center">
                                    <button type="button" className="btn btn-secondary form-group mt-2 mb-2" onClick={() => handleRemoveWorkExperience(index)}>
                                        Remove
                                    </button>
                                </div>
                            </div>
                        ))}
                        <div className="d-flex justify-content-center">
                            <button className="btn btn-primary form-group mb-2 mt-2" type="button" onClick={handleAddWorkExperience}>
                                Add Work Experience
                            </button>
                        </div>

                        <div className="form-group mb-2">
                            <label htmlFor="expertise_tags">Expertise Tags</label>
                            <Select
                                value={Array.isArray(formData.expertise_tags) ? formData.expertise_tags.map(tag => ({
                                    value: tag.tag_id,
                                    label: tag.uTags
                                })) : []}
                                id="expertise_tags"
                                name="expertise_tags"
                                onChange={(selectedOptions) => {
                                    const selectedValues = selectedOptions ? selectedOptions.map(option => ({ expertise_id: option.value, uTags: option.label })) : [];
                                    setFormData(prevFormData => ({ ...prevFormData, expertise_tags: selectedValues }));
                                }}
                                options={userTagDetails
                                    .filter((tags) => tags.isActive === 1)
                                    .map((tags) => ({
                                        value: tags._id,
                                        label: tags.uTags,
                                    }))
                                }
                                getOptionLabel={(option) => option.label}
                                isMulti
                            />
                        </div>
                        <div className="form-group mb-2">
                            <label htmlFor="address">Address</label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="address"
                                placeholder="Address"
                                value={formData.address}
                                onChange={handleInputChange}
                                validate={{
                                    required: { value: true, errorMessage: 'Please enter your Address' },
                                }}
                            />
                        </div>
                        <div className="form-group mb-2">
                            <label htmlFor="bio">Bio</label>
                            <AvField
                                type="textarea"
                                className="form-control"
                                name="bio"
                                placeholder="Bio"
                                value={formData.bio}
                                onChange={handleInputChange}
                                validate={{
                                    required: { value: true, errorMessage: 'Please enter your Bio' },
                                }}
                            />
                        </div>
                        <div className="form-group mt-4 d-flex flex-column align-items-center justify-content-center">
                            <label className="work-experience-label">Social Accounts</label>
                        </div>
                        {Array.isArray(formData.linkedAccounts) && formData.linkedAccounts.map((social, index) => (
                            <div key={index} className="form-group mb-2">
                                <div className="form-group mb-2">
                                    <label htmlFor={`socialType${index}`}>Social Type</label>
                                    <Select
                                        id={`socialType${index}`}
                                        name={`socialType${index}`}
                                        value={{ value: social.type, label: social.type }}
                                        onChange={(selectedOption) =>
                                            handleSocialAccountChange(index, 'type', selectedOption.value)
                                        }
                                        options={[
                                            { value: 'Facebook', label: 'Facebook' },
                                            { value: 'Twitter', label: 'Twitter' },
                                            { value: 'Instagram', label: 'Instagram' },
                                            { value: 'Linkedin', label: 'Linkedin' },
                                            { value: 'Google+', label: 'Google+' },
                                            { value: 'Others', label: 'Others' },
                                        ]}
                                    />
                                </div>
                                <div className="form-group mb-2">
                                    <label htmlFor={`socialLink${index}`}>Social Link</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={`socialLink${index}`}
                                        name={`socialLink${index}`}
                                        placeholder="Social Link"
                                        value={social.url}
                                        onChange={(e) => handleSocialAccountChange(index, 'url', e.target.value)}
                                    />
                                </div>
                                <div className="d-flex justify-content-center">
                                    <button type="button" className="btn btn-secondary form-group mt-2" onClick={() => handleRemoveLinkedAccount(index)}>
                                        Remove
                                    </button>
                                </div>
                            </div>
                        ))}
                        <div className="mt-3 mb-2 d-flex justify-content-center">

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={addSocialAccountField}
                            >
                                Add Social Account
                            </button>
                        </div>
                        <div className="form-group mb-2 mt-4">
                            <div className="row">
                                <div className="col-md-3 d-flex align-items-center justify-content-center">
                                    <div className="prev-image-container">
                                        <img
                                            src="static/media/avatar-4.jpg"
                                            style={{ width: '50px', height: '70px' }}
                                            alt="Profile"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-9 mb-2 mt-2">
                                    <label htmlFor="o_photo" className="custom-file-label">
                                        Profile Picture
                                        <input
                                            type="file"
                                            className=" form-control"

                                            id="o_photo"
                                            name="o_photo"
                                            onChange={handleO_photoChange}
                                            style={{ width: '100%' }}

                                            required={formSubmitted && !selectedUser.o_photo}
                                        />
                                        {formSubmitted && !selectedUser.o_photo && (
                                            <div className="text-danger">{errorMessageModel || 'Please upload a file.'}</div>
                                        )}
                                    </label>
                                    {selectedUser.o_photo && (
                                        <div className="text-success">File uploaded successfully.</div>
                                    )}
                                    <small className="form-text text-muted mt-2">
                                        Allowed file types: PNG, JPG, JPEG. File ratio: 1:1. File size limit: 2MB. Dummy
                                        image icon size: 300x300px.
                                    </small>
                                </div>
                            </div>
                        </div>
                        <SetAlert alertMessage={alertMessage} setAlertMessage={setAlertMessage} />

                        <ModalFooter>
                            <Button color="secondary" onClick={toggleAddModal}>
                                Cancel
                            </Button>
                            <Button color="primary" type="submit" disabled={submitting}>
                                {submitting ? "Adding..." : "Add"}
                            </Button>
                        </ModalFooter>
                    </AvForm>
                </ModalBody>
            </Modal>

            {isUserSelected && (
                <Modal isOpen={editModalOpen} toggle={toggleEditModal} backdrop="static">
                    <ModalHeader toggle={toggleEditModal}>Edit Organiser</ModalHeader>
                    <ModalBody>
                        <SetAlert alertMessage={alertMessage} setAlertMessage={setAlertMessage} />

                        <AvForm onValidSubmit={handleEditUser}>
                            <div className="form-group mb-2">
                                <label htmlFor="role">Role</label>
                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    name="role"
                                    placeholder="Select Role"
                                    value={{ value: selectedUser.role, label: selectedUser.role }}
                                    options={[
                                        { value: 'admin', label: 'Admin' },
                                        { value: 'user', label: 'User' },
                                    ]}
                                    onChange={(selectedOption) => {
                                        setFormData({ ...formData, role: selectedOption ? selectedOption.value : '' });
                                        setSelectedUser({ ...selectedUser, role: selectedOption ? selectedOption.value : '' });
                                    }}
                                />
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group mb-2">
                                        <label htmlFor="fname">First Name</label>
                                        <AvField
                                            type="text"
                                            className="form-control"
                                            name="fname"
                                            placeholder="Name"
                                            value={selectedUser.fname}
                                            onChange={handleEditInputChange}
                                            validate={{
                                                required: { value: true, errorMessage: 'Please enter your first name' },
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group mb-2">
                                        <label htmlFor="lname">Last Name</label>
                                        <AvField
                                            type="text"
                                            className="form-control"
                                            name="lname"
                                            placeholder="Last Name"
                                            value={selectedUser.lname}
                                            onChange={handleEditInputChange}
                                            validate={{
                                                required: { value: true, errorMessage: 'Please enter your last name' },
                                            }}
                                        />
                                    </div>

                                </div>
                            </div>

                            <div className="form-group mb-2">
                                <label htmlFor="phone">Phone</label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="phone"
                                    placeholder="Phone"
                                    value={selectedUser.phone}
                                    onKeyDown={handleContactNumberKeyDown}
                                    pattern="\d*"
                                    maxLength="11"
                                    minLength="10"
                                    onChange={handleEditInputChange}
                                    validate={{
                                        required: { value: true, errorMessage: 'Please enter your phone number' },
                                    }}
                                />
                            </div>
                            <div className="form-group mb-2">
                                <label htmlFor="email">Email</label>
                                <AvField
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    placeholder="Email"
                                    value={selectedUser.email}
                                    onChange={handleEditInputChange}
                                    validate={{
                                        required: { value: true, errorMessage: 'Please enter your email address' },
                                        email: { errorMessage: 'Invalid email address' },
                                    }}
                                />
                            </div>
                            <div className="form-group mb-2">
                                <label htmlFor="password">Password</label>
                                <AvField
                                    type="password"
                                    className="form-control"
                                    name="password"
                                    placeholder="password"
                                    value={selectedUser.password}
                                    onChange={handleEditInputChange}
                                    validate={{
                                        required: { value: true, errorMessage: 'Please enter your password' },

                                    }}
                                />
                            </div>

                            <div className="form-group mb-2">
                                <label htmlFor="interest_tags">Interest Tags</label>
                                <Select
                                    value={Array.isArray(selectedUser.interest_tags) ? selectedUser.interest_tags.map(tagId => ({
                                        value: tagId,
                                        label: userTagDetails.find(tag => tag._id === tagId)?.uTags || ''
                                    })) : []}
                                    id="interest_tags"
                                    name="interest_tags"
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                        setFormData(prevFormData => ({ ...prevFormData, interest_tags: selectedValues }));
                                        setSelectedUser(prevSelectedUser => ({
                                            ...prevSelectedUser,
                                            interest_tags: selectedValues,
                                        }));
                                    }}
                                    options={userTagDetails
                                        .filter((tags) => tags.isActive === 1)
                                        .map((tags) => ({
                                            value: tags._id,
                                            label: tags.uTags,
                                        }))
                                    }
                                    getOptionLabel={(option) => option.label}
                                    isMulti={true}
                                />
                            </div>

                            <div className="form-group mt-4 d-flex flex-column align-items-center justify-content-center">
                                <label className="work-experience-label">Work Experience</label>
                            </div>
                            {Array.isArray(selectedUser.workExperience) && selectedUser.workExperience.map((experience, index) => (
                                <div key={index}>
                                    <div className="form-group mb-2">

                                        <AvField
                                            type="text"
                                            name={`companyName-${index}`}
                                            value={experience.companyName}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                const updatedExperience = {
                                                    ...experience,
                                                    companyName: newValue,
                                                };
                                                handleEditWorkExperience(index, updatedExperience);
                                            }}
                                            label="Company Name"
                                            placeholder="Enter Company Name"
                                            required
                                        />


                                    </div>
                                    <div className="form-group mb-2">

                                        <AvField
                                            type="url"
                                            name={`companyLogo-${index}`}
                                            value={experience.companyLogo}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                const updatedExperience = {
                                                    ...experience,
                                                    companyLogo: newValue,
                                                };
                                                handleEditWorkExperience(index, updatedExperience);
                                            }}
                                            label="Company Logo"
                                            placeholder="Enter Company Logo URL"
                                            required
                                        />

                                    </div>
                                    <div className="form-group mb-2">

                                        <AvField
                                            type="text"
                                            name={`position-${index}`}
                                            value={experience.position}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                const updatedExperience = {
                                                    ...experience,
                                                    position: newValue,
                                                };
                                                handleEditWorkExperience(index, updatedExperience);
                                            }}
                                            label="Position"
                                            placeholder="Enter your position"
                                            required
                                        />

                                    </div>
                                    <div className="row">
                                        <div className="form-group mb-2 col-5">
                                            <label htmlFor={`startDate${index}`}>Start Date</label>
                                            <Flatpickr
                                                className={`form-control ${isInvalidStartDate ? 'is-invalid' : ''}`}
                                                value={experience.startDate}
                                                onChange={(value) => {
                                                    handleStartDateChange(index, value);
                                                }}
                                                options={{
                                                    dateFormat: 'Y-m-d',
                                                }}
                                                placeholder="Start Date"
                                            />
                                            {isInvalidStartDate && (
                                                <div className="invalid-feedback">Please select a valid Start Date.</div>
                                            )}
                                        </div>
                                        <div className="form-group mb-2 col-5">
                                            <label htmlFor={`endDate${index}`}>End Date</label>
                                            {experience.endDate === 'Present' ? (
                                                <input
                                                    className={`form-control ${isInvalidEndDate ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    name={`endDate-${index}`}
                                                    placeholder="End Date"
                                                    value="Present"
                                                    onChange={(e) => {
                                                        const updatedWorkExperience = [...formData.workExperience];
                                                        updatedWorkExperience[index].endDate = e.target.value;
                                                        setFormData({ ...formData, workExperience: updatedWorkExperience });
                                                        validateEndDate('Present', experience.startDate);
                                                    }}
                                                    disabled
                                                />
                                            ) : (
                                                <Flatpickr
                                                    className={`form-control ${isInvalidEndDate ? 'is-invalid' : ''}`}
                                                    value={experience.endDate}
                                                    onChange={(value) => {
                                                        handleEndDateChange(index, value);

                                                    }}
                                                    options={{
                                                        dateFormat: 'Y-m-d',
                                                    }}
                                                    placeholder="End Date"
                                                />
                                            )}
                                            {isInvalidEndDate && (
                                                <div className="invalid-feedback">Please select a valid End Date.</div>
                                            )}
                                        </div>
                                        <div className="col-2">
                                            <label htmlFor={`presentCheckbox${index}`} className="text-center">Present</label>
                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                <input
                                                    className="form-check-input text-center"
                                                    type="checkbox"
                                                    checked={selectedUser.workExperience[index]?.endDate === 'Present'}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        const updatedUser = { ...selectedUser };
                                                        updatedUser.workExperience[index].endDate = isChecked ? 'Present' : '';
                                                        setSelectedUser(updatedUser);
                                                        setIsInvalidStartDate(false);
                                                        setIsInvalidEndDate(false);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                    </div>

                                    <div className="form-group mb-2">

                                        <AvField
                                            type="textarea"
                                            name={`shortDesc-${index}`}
                                            value={experience.shortDesc}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                const updatedExperience = {
                                                    ...experience,
                                                    shortDesc: newValue,
                                                };
                                                handleEditWorkExperience(index, updatedExperience);
                                            }}
                                            label="Short Description"
                                            placeholder="Enter Short Description"
                                            required
                                        />

                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <button type="button" className="btn btn-secondary form-group mt-2 mb-2" onClick={() => handleRemoveWorkExperienceEdit(index)}>
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            ))}
                            <div className="d-flex justify-content-center">
                                <button className="btn btn-primary form-group mb-2 mt-2" type="button" onClick={handleAddWorkExperienceEdit}>
                                    Add Work Experience
                                </button>
                            </div>

                            <div className="form-group mb-2">
                                <label htmlFor="expertise_tags">Expertise Tags</label>
                                <Select
                                    value={Array.isArray(selectedUser.expertise_tags) ? selectedUser.expertise_tags.map(tagId => ({
                                        value: tagId,
                                        label: userTagDetails.find(tag => tag._id === tagId)?.uTags || ''
                                    })) : []}
                                    id="expertise_tags"
                                    name="expertise_tags"
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                        setFormData(prevFormData => ({ ...prevFormData, expertise_tags: selectedValues }));
                                        setSelectedUser(prevSelectedUser => ({
                                            ...prevSelectedUser,
                                            expertise_tags: selectedValues,
                                        }));
                                    }}
                                    options={userTagDetails
                                        .filter((tags) => tags.isActive === 1)
                                        .map((tags) => ({
                                            value: tags._id,
                                            label: tags.uTags,
                                        }))
                                    }
                                    getOptionLabel={(option) => option.label}
                                    isMulti={true}
                                />
                            </div>
                            <div className="form-group mb-2">
                                <label htmlFor="address">Address</label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="address"
                                    placeholder="Address"
                                    value={selectedUser.address}
                                    onChange={handleEditInputChange}
                                    validate={{
                                        required: { value: true, errorMessage: 'Please enter your Address' },
                                    }}
                                />
                            </div>
                            <div className="form-group mb-2">
                                <label htmlFor="bio">Bio</label>
                                <AvField
                                    type="textarea"
                                    className="form-control"
                                    name="bio"
                                    placeholder="Bio"
                                    value={selectedUser.bio}
                                    onChange={handleEditInputChange}
                                    validate={{
                                        required: { value: true, errorMessage: 'Please enter your Bio' },
                                    }}
                                />
                            </div>
                            <div className="form-group mt-4 d-flex flex-column align-items-center justify-content-center">
                                <label className="work-experience-label">Social Accounts</label>
                            </div>
                            {Array.isArray(selectedUser.linkedAccounts) && selectedUser.linkedAccounts.map((social, index) => (
                                <div key={index} className="form-group mb-2">
                                    <div className="form-group mb-2">
                                        <label htmlFor={`socialType${index}`}>Social Type</label>
                                        <Select
                                            id={`socialType${index}`}
                                            name={`socialType${index}`}
                                            value={{ value: social.type || '', label: social.type || '' }}
                                            onChange={(selectedOption) =>
                                                handleEditSocialAccountChange(index, 'type', selectedOption.value)
                                            }
                                            options={[
                                                { value: 'Facebook', label: 'Facebook' },
                                                { value: 'Twitter', label: 'Twitter' },
                                                { value: 'Instagram', label: 'Instagram' },
                                                { value: 'Linkedin', label: 'Linkedin' },
                                                { value: 'Google+', label: 'Google+' },
                                                { value: 'Others', label: 'Others' },
                                            ]}
                                        />
                                    </div>
                                    <div className="form-group mb-2">
                                        <label htmlFor={`socialLink${index}`}>Social Link</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id={`socialLink${index}`}
                                            name={`socialLink${index}`}
                                            placeholder="Social Link"
                                            value={social.url || ''}
                                            onChange={(e) => handleEditSocialAccountChange(index, 'url', e.target.value)}
                                        />
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <button type="button" className="btn btn-secondary form-group mt-2 mb-2" onClick={() => handleRemoveLinkedAccountEdit(index)}>
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            ))}

                            <div className="mt-3 mb-2 d-flex justify-content-center">

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={addEditSocialAccountField}
                                >
                                    Add Social Account
                                </button>
                            </div>
                            <div className="mt-4 form-group mb-2 mt-2">
                                <div className="row">
                                    <div className="col-md-3 d-flex align-items-center justify-content-center">
                                        <div className="prev-image-container">
                                            <img
                                                src="static/media/avatar-4.jpg"
                                                style={{ width: '50px', height: '70px' }}
                                                alt="Profile"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-9 mb-2">
                                        <label htmlFor="o_photo" className="custom-file-label">
                                            Profile Picture
                                            <input
                                                type="file"
                                                className=" form-control"
                                                id="o_photo"
                                                name="o_photo"
                                                onChange={handleO_photoChange}
                                                style={{ width: '100%' }}

                                                required={formSubmitted && !selectedUser.o_photo}
                                            />
                                            {formSubmitted && !selectedUser.o_photo && (
                                                <div className="text-danger">{errorMessageModel || 'Please upload a file.'}</div>
                                            )}
                                        </label>
                                        {selectedUser.o_photo && (
                                            <div className="text-success">File uploaded successfully.</div>
                                        )}
                                        <small className="form-text text-muted mt-2">
                                            Allowed file types: PNG, JPG, JPEG. File ratio: 1:1. File size limit: 2MB. Dummy
                                            image icon size: 300x300px.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <ModalFooter>
                                <Button color="primary" type="submit" disabled={submitting}>
                                    {submitting ? "Editting..." : "Edit"}
                                </Button>
                                <Button color="secondary" onClick={toggleEditModal}>
                                    Cancel
                                </Button>
                            </ModalFooter>
                        </AvForm>
                    </ModalBody>
                </Modal>
            )}


            {isUserSelected && (
                <Modal isOpen={isModalOpenUser} toggle={handleCloseModalUser}>
                    <ModalHeader toggle={handleCloseModalUser}>User Details</ModalHeader>
                    <ModalBody>
                        <div className="form-group  mb-2">
                            <Card>
                                <CardBody>
                                    <div className="table-responsive">
                                        <Table striped className="mb-0">
                                            <tbody>

                                                <tr>
                                                    <th>First Name</th>
                                                    <td>
                                                        {selectedUser.fname || 'N/A'}

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Last Name</th>
                                                    <td>{selectedUser.lname || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <th>Phone</th>
                                                    <td>{selectedUser.phone || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <th>Email</th>
                                                    <td>{selectedUser.email || 'N/A'}</td>
                                                </tr>

                                                <tr>
                                                    <th>Interest</th>
                                                    <td>
                                                        {selectedUser.interest_tags && selectedUser.interest_tags.length > 0 ? (
                                                            selectedUser.interest_tags.map((tagId, index) => {
                                                                const matchingTag = userTagDetails.find((tag) => tag._id === tagId);
                                                                if (matchingTag) {
                                                                    return (
                                                                        <div key={index}>
                                                                            {matchingTag.uTags}
                                                                        </div>
                                                                    );
                                                                }
                                                                return null;
                                                            })
                                                        ) : (
                                                            'N/A'
                                                        )}
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <th>Work Experience</th>
                                                    <td>
                                                        {selectedUser.workExperience && selectedUser.workExperience.length > 0 ? (
                                                            selectedUser.workExperience.map((exp, index) => (
                                                                <div key={index}>
                                                                    {`${exp.position} at ${exp.companyName}`}
                                                                    <br />
                                                                    {`(${exp.startDate} - ${exp.endDate})`}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            'N/A'
                                                        )}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>Expertise</th>
                                                    <td>
                                                        {selectedUser.expertise_tags && selectedUser.expertise_tags.length > 0 ? (
                                                            selectedUser.expertise_tags.map((tagId, index) => {
                                                                const matchingTag = userTagDetails.find((tag) => tag._id === tagId);
                                                                if (matchingTag) {
                                                                    return (
                                                                        <div key={index}>
                                                                            {matchingTag.uTags}
                                                                        </div>
                                                                    );
                                                                }
                                                                return null;
                                                            })
                                                        ) : (
                                                            'N/A'
                                                        )}
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <th>Address</th>
                                                    <td>{selectedUser.address || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <th>Bio</th>
                                                    <td>{selectedUser.bio || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <th>Registration Date</th>
                                                    <td>{selectedUser.createdDate || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <th style={{ verticalAlign: 'start' }}>Profile Photo</th>
                                                    <td style={{ verticalAlign: 'start' }}>
                                                        {selectedUser.o_photo && (
                                                            <div>
                                                                <a
                                                                    href={selectedUser.o_photo}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    <img
                                                                        src={selectedUser.o_photo}
                                                                        alt="Profile Picture"
                                                                        style={{
                                                                            width: '50px',
                                                                            margin: '5px',
                                                                            float: 'left',  // Align the image to the left
                                                                        }}
                                                                    />
                                                                </a>
                                                            </div>
                                                        )}
                                                        {!selectedUser?.o_photo && (
                                                            <div style={{ marginLeft: '60px' }}>N/A</div>
                                                        )}
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                        <ModalFooter>
                            <Button color="secondary" onClick={handleCloseModalUser}>
                                Cancel
                            </Button>
                        </ModalFooter>
                    </ModalBody>
                </Modal>
            )}
        </div>
    );
}

export default OrganiserMaster;
